import { CarouselElementType } from "../CarouselElementType";
import { CarouselElement, CarouselElementMode } from "../CarouselElement";
import { CarouselSelect } from "../CarouselSelect";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { sleep } from "../../../../library-js/animation/sleep";
import { nextFrame } from "../../../../library-js/animation/nextFrame";
import { Loader } from "../../../../library-js/dom-tools/Loader";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { AnimatableElement } from "../AnimatableElement";
import { RenderQuality } from "../../../../library-templates/render--quality/RenderQuality";
import { UserAgentDeviceTypes } from "../../../../library-js/dom/UserAgentDeviceType";



export class ZoomLayers extends CarouselElement
{  
  static readonly type = new ElementType( "zoom-layers" );
  static readonly bgElement = new ElementType( "bg-element" );
  static readonly heroElement = new ElementType( "hero-element" );
  static readonly textElement = new ElementType( "text-element" );

  constructor( s:CarouselSelect, e:Element )
  {
    super( s, e, CarouselElementMode.Landscape );
    this.grabElements();
  }

  bg:HTMLElement;
  hero:HTMLElement;
  text:HTMLElement;
  cta:HTMLElement;

  grabElements()
  {
    this.bg   = ZoomLayers.bgElement.query( this._element ) as HTMLElement;
    this.hero = ZoomLayers.heroElement.query( this._element ) as HTMLElement;
    this.text = ZoomLayers.textElement.query( this._element ) as HTMLElement;
    this.cta  = CarouselSelect.ctaElement.query( this._element ) as HTMLElement;
  }
  
  async transitionIn():Promise<void>
  {
    
    let layers:AnimatableElement[] = 
    [
      { element:this.bg, keys:[ { attribute:"backgroundSize", from:"105%", to:"100%"} ] },

      { element:this.hero, keys:[ { attribute:"backgroundSize", from:"110%", to:"100%"} ] },

      { element:this.text, keys:[ { attribute:"backgroundSize", from:"120%", to:"100%"} ] },

      { element:this.cta, keys:[ { attribute:"transform", from:"perspective(50em) scale(120%)", to:"perspective(50em) scale(100%)" } ] }
    ];

    AnimatableElement.animate( layers );
    

    await sleep( this.transitionOutDurationMs );
    return Promise.resolve();
  }

  async transitionOut():Promise<void>
  {
    if ( UserAgentDeviceTypes.current != UserAgentDeviceTypes.PC || RenderQuality.isHighQuality )
    {
      
      this.bg.style.backgroundSize     = "105%";
      this.hero.style.backgroundSize   = "110%";
      this.text.style.backgroundSize   = "120%";
      this.cta.style.transform = "perspective(50em) scale(120%)";
      
    }

    await sleep( this.transitionOutDurationMs );

    return Promise.resolve(); 
  }

  
}